module.exports = __webpack_public_path__ + "img/pdd_tip.8c180a63.png";